import { render } from "./CargoGroupCatalogue.vue?vue&type=template&id=4fddc514&ts=true"
import script from "./CargoGroupCatalogue.vue?vue&type=script&lang=ts"
export * from "./CargoGroupCatalogue.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Work\\АСУП\\OptiLoadingPaper\\Loading\\loading_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__